angular.module('LegendSettings').controller('LegendController', [
  '$scope',
  '$filter',
  '$sce',
  '$timeout',
  '$uibModal',
  'LegendService',
  '$q',
  function ($scope, $filter, $sce, $timeout, $uibModal, LegendService, $q) {
    var settings = jQuery('#settings');
    var mapLegend = settings.data('map-legend');
    var chartLegend = settings.data('chart-legend');
    var relatedMapLegends = settings.data('related-map-legends') ? settings.data('related-map-legends') : false;
    var relatedChartLegends = settings.data('related-chart-legends') ? settings.data('related-chart-legends') : false;
    var layerUid = settings.data('layer-uid');
    var colorSetPromise;
    var mapLegendPromise;
    var chartLegendPromise;
    var districtPromise;
    var indicatorTypeUid = settings.data('indicator-type');

    $scope.loading = true;
    $scope.disable = function () {
      $scope.disabled = true;
    };

    districtPromise = LegendService.getDistrictsFromLayer(layerUid)
      .then(function (data) {
        $scope.districts = data;
      });

    $scope.loadData = function () {
      if (mapLegend) {
        mapLegendPromise = LegendService.getLegend(mapLegend)
          .then(function (data) {
            $scope.mapLegend = data;
          });
      } else if (relatedMapLegends) {
        LegendService.getRelated(relatedMapLegends)
          .then(function (data) {
            $scope.relatedMapLegends = data;
          });
        mapLegendPromise = true;
      } else {
        mapLegendPromise = true;
      }

      if (chartLegend) {
        chartLegendPromise = LegendService.getLegend(chartLegend)
          .then(function (data) {
            $scope.chartLegend = data;
          });
      } else if (relatedChartLegends) {
        LegendService.getRelated(relatedChartLegends)
          .then(function (data) {
            $scope.relatedChartLegends = data;
          });
        chartLegendPromise = true;
      } else {
        chartLegendPromise = true;
      }

      colorSetPromise = LegendService.getColorSets()
        .then(function (data) {
          $scope.colorSets = data;
        });

      if (indicatorTypeUid) {
        LegendService.getIndicatorTypeLists(indicatorTypeUid)
          .then(function (data) {
            $scope.indicatorType = data;
          });
      }

      $q.all([mapLegendPromise, colorSetPromise]).then(function () {
        $scope.mapColorSet = getColorSet($scope.mapLegend);
      });

      $q.all([chartLegendPromise, colorSetPromise]).then(function () {
        $scope.chartColorSet = getColorSet($scope.chartLegend);
      });
    };

    $scope.getColorSet = function (legend) {
      return getColorSet(legend);
    };

    $scope.copyLegend = function (legendUid, type) {
      LegendService.copyLegend(legendUid, type)
        .then(function (data) {
          if (data) {
            if (type === 'map_legend') {
              mapLegend = data;
              settings.data('map-legend', data);
            } else if (type === 'chart_legend') {
              chartLegend = data;
              settings.data('chart-legend', data);
            }
          }
          $scope.loadData();
        });
    };

    function getColorSet(legend) {
      if (!legend) return;
      var colorSetId = legend.colorSet;
      var result = 0;
      if (colorSetId) {
        angular.forEach($scope.colorSets, function (colorSet) {
          if (colorSetId == colorSet.uid) {
            result = colorSet;
          }
        });
        return result;
      }
    }

    $scope.createLegend = function (type) {
      return $uibModal.open({
        templateUrl: '/_assets/19afb7c62e901835de82505ec5bff8a5/JavaScript/Hyperion/LegendSettings/CreateLegend.html',
        size: 'lg',
        controller: 'LegendModalController',
        resolve: {
          data: function () {
            return {
              legend: type === 'map_legend' ? $scope.mapLegend : $scope.chartLegend,
              type: type,
              colorSets: $scope.colorSets,
              indicatorType: $scope.indicatorType,
              districts: $scope.districts
            };
          }
        }
      }).result
        .then(function (legend) {
          if (type === 'map_legend') {
            $scope.mapLegend = angular.copy(legend);
            $scope.mapColorSet = getColorSet($scope.mapLegend);
          } else {
            $scope.chartLegend = angular.copy(legend);
            $scope.chartColorSet = getColorSet($scope.chartLegend);
          }

          return LegendService.persistLegend(legend, type).then(function (newLegendUid) {
            if (type === 'map_legend') {
              mapLegend = newLegendUid;
            } else {
              chartLegend = newLegendUid;
            }
            $scope.loadData();
          });
        });
    };

    $scope.updateLegend = function (type, legend, colorSet) {
      return $uibModal.open({
        templateUrl: '/_assets/19afb7c62e901835de82505ec5bff8a5/JavaScript/Hyperion/LegendSettings/CreateLegend.html',
        size: 'lg',
        controller: 'LegendModalController',
        resolve: {
          data: function () {
            return {
              legend: legend,
              type: type,
              selectedColorSet: colorSet,
              colorSets: $scope.colorSets,
              indicatorType: $scope.indicatorType,
              districts: $scope.districts
            };
          }
        }
      }).result
        .then(function (legend) {
          if (type === 'map_legend') {
            $scope.mapLegend = angular.copy(legend);
            $scope.mapColorSet = getColorSet($scope.mapLegend);
          } else {
            $scope.chartLegend = angular.copy(legend);
            $scope.chartColorSet = getColorSet($scope.chartLegend);
          }
          return LegendService.persistLegend(legend, type).then(function () {
            $scope.loadData();
          });
        });
    };

    $scope.removeLegend = function (legend, type) {
      var test = confirm('Sind Sie sicher, dass Sie die Legende löschen wollen?');
      if (test) {
        if ($scope.mapLegend && legend.uid == $scope.mapLegend.uid) {
          $scope.mapLegend = null;
          settings.data('map-legend', 0);
          mapLegend = 0;
        }
        if ($scope.chartLegend && legend.uid == $scope.chartLegend.uid) {
          $scope.chartLegend = null;
          settings.data('chart-legend', 0);
          chartLegend = 0;
        }
        LegendService.removeLegend(legend.uid, type).then(function () {
          $scope.loadData();
        });
      }
    };
  }]);
